/* ============================================================
   SAM-730 — private events.

   A private event is listed on capcana.app with a lock and its details stay
   visible; guests need the event code (event.pin_code) only to register.
   "Private" means the event type named 'private' (case-insensitive). The
   backend also returns `is_private` on GET /event/event; until that lambda is
   deployed we fall back to the expanded event_type name.
   ============================================================ */

export const isPrivateEventTypeName = (name?: string | null): boolean =>
  (name || '').trim().toLowerCase() === 'private';

/** Whether the selected event type id is the Private type. */
export const isPrivateEventTypeId = (
  eventTypeId: number | string | null | undefined,
  eventTypes: ReadonlyArray<{ id: number | string; name?: string | null }> | null | undefined,
): boolean => {
  if (eventTypeId == null || eventTypeId === '') return false;
  const type = (eventTypes || []).find((t) => String(t.id) === String(eventTypeId));
  return isPrivateEventTypeName(type?.name);
};

/** Public/preview event → private? `is_private` from the API wins; else the event type name. */
export const isPrivateEvent = (
  event: { is_private?: boolean | null; event_type?: { name?: string | null } | null } | null | undefined,
): boolean => {
  if (!event) return false;
  if (typeof event.is_private === 'boolean') return event.is_private;
  return isPrivateEventTypeName(event.event_type?.name);
};
